<template>
  <div class="content">
    <s-location notice title="공지사항" />

    <table class="tbl01 view01">
      <thead>
        <tr>
          <td class="title">
            <span v-html="sitem.titl" />
            <div class="td_date">
              {{ sitem.incmgdt | moment("YYYY.MM.DD") }} | 조회수 {{ sitem.hit }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="cont"><div v-html="sitem.cont" /></td>
        </tr>
        <tr v-if="sitem.attachid || sitem.attachid2 || sitem.attachid3">
          <td class="cont">
            <a v-if="sitem.attachid"  :href="`${ $api }/file/notice/${ sitem.attachid }`" ><span class="btn black01 s down ">첨부파일</span></a>
            <a v-if="sitem.attachid2" :href="`${ $api }/file/notice/${ sitem.attachid2 }`"><span class="btn black01 s down ml10">첨부파일2</span></a>
            <a v-if="sitem.attachid3" :href="`${ $api }/file/notice/${ sitem.attachid3 }`"><span class="btn black01 s down ml10">첨부파일3</span></a>
          </td>
        </tr>
      </thead>
    </table>

    <div class="btn_group">
      <a @click="$router.push('board_list')" class="btn right" style="margin-left: 20px; ">목록</a>
    </div>
  </div>
</template>

<script>
let ui
export default {
  data() {
    return {
      sitem : {}
    }
  },
  created() {
    ui = this.$ui;
    this.addhit()
  },
  methods: {
    addhit(){
      ui.httpGet('/proc/N_ANN_UPD_HIT',
        {
            seq    : this.$route.query.seq
        },
        ret => {
          const { msg, status } = ret.data.rs1[0]

          if (status == '0'){
            this.getData()
            }
        })
    },
    getData() {
      ui.httpGet('/proc/N_ANN_SEL_DTL_ADM',
        {
            seq    : this.$route.query.seq
        },
        ret => {
          // 증표종류가 전체가 아닐 경우 DB에서 받아온 증표 번호 그대로 출력, 아니면 받아온 증표 번호 끝자리 0으로 대체
          this.sitem = ret.data.rs1[0]
        })
    },

  },
}
</script>

<style scoped>
table.board td {
  border-right: none !important;
  border-left: none !important;
}

.board td.title { padding: 20px 10px; }
.board td.cont { padding: 20px 10px; }
.tbl01 tr, .tbl01 td { border-left:none; border-right:none;}
</style>